"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidDate = exports.getYearRecurrenceDay = exports.getMonthRecurrenceDay = exports.getLocales = exports.getLocale = exports.formatUnixTimestamp = exports.formatDatetime = exports.convertTimestamp = exports.convertRFCDateTime = exports.convertRFCDate = exports.convertMomentToInstanceDateTimeId = exports.convertMomentToInstanceDateId = exports.convertMoment = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("@babel/polyfill/noConflict");
var _moment = _interopRequireDefault(require("moment"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getLocales = exports.getLocales = function getLocales() {
  if (navigator && Array.isArray(navigator.languages) && navigator.languages.length > 0) {
    return navigator.languages;
  }
  return ['en-US'];
};
var getLocale = exports.getLocale = function getLocale() {
  return getLocales()[0];
};
var isValidDate = exports.isValidDate = function isValidDate(data) {
  if (data === null || data === undefined) {
    return false;
  }
  var ret = _objectSpread({}, data);
  if (typeof data.year === 'string') {
    ret.year = parseInt(data.year, 10);
  }
  if (typeof data.month === 'string') {
    ret.month = parseInt(data.month, 10);
  }
  ret.month = data.month - 1;
  if (typeof data.day === 'string') {
    ret.day = parseInt(data.day, 10);
  }
  var m = (0, _moment["default"])(ret);
  return m.isValid();
};
var convertMomentToInstanceDateId = exports.convertMomentToInstanceDateId = function convertMomentToInstanceDateId(m) {
  return m.format('YYYYMMDD');
};
var convertMomentToInstanceDateTimeId = exports.convertMomentToInstanceDateTimeId = function convertMomentToInstanceDateTimeId(m) {
  return m.utc().format('YYYYMMDD[T]HHmmss[Z]');
};
var convertRFCDate = exports.convertRFCDate = function convertRFCDate(date) {
  return (0, _moment["default"])(date, 'YYYY-MM-DD');
};
var convertRFCDateTime = exports.convertRFCDateTime = function convertRFCDateTime(dateTime, timeZone) {
  return _moment["default"].parseZone(dateTime);
};
//-1 means last day of month, +1 means first day of month
var getMonthRecurrenceDay = exports.getMonthRecurrenceDay = function getMonthRecurrenceDay(m) {
  var date = m.date();
  if (date <= 26) {
    return date;
  }
  return date - m.daysInMonth() - 1;
};
//-1 means last day of year, +1 means first day of year
var getYearRecurrenceDay = exports.getYearRecurrenceDay = function getYearRecurrenceDay(m) {
  var date = m.dayOfYear();
  if (date <= 360) {
    return date;
  }
  if (m.isLeapYear()) {
    return date - 366 - 1;
  }
  return date - 365 - 1;
};
/**
 * Helper method that converts a UNIX timestamp into a Moment object.
 */
var convertTimestamp = exports.convertTimestamp = function convertTimestamp(timestamp) {
  if (typeof timestamp === 'number') {
    return _moment["default"].unix(timestamp);
  } else {
    return _moment["default"].unix(parseInt(timestamp, 10));
  }
};

/**
 * Helper method that converts a Moment object into UNIX timestamp.
 */
var convertMoment = exports.convertMoment = function convertMoment(momentObj) {
  return momentObj.unix();
};

/**
 * Formats the datetime into the application's standard format.
 */
var formatDatetime = exports.formatDatetime = function formatDatetime(datetime, format) {
  return datetime.format(format);
};
var formatUnixTimestamp = exports.formatUnixTimestamp = function formatUnixTimestamp(timeStamp) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'LLL';
  var locale = arguments.length > 2 ? arguments[2] : undefined;
  if (!locale) {
    locale = getLocale();
  }
  return _moment["default"].unix(timeStamp).locale(locale).format(format);
};
//# sourceMappingURL=index.js.map